import { render, staticRenderFns } from "./FormFilter.vue?vue&type=template&id=96c51320&"
import script from "./FormFilter.vue?vue&type=script&lang=js&"
export * from "./FormFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports